import { ReportableError } from '../model/reportable-error';
import { useMutation } from '@apollo/client';
import { GqlReportErrorSchema } from './schema.gql';

type Input = {
  error: {
    cause: string;
    loggedInUser?: {
      id?: number;
      phone?: string;
    };
  };
};

type Output = {
  value: string;
};

export const useReportError = () => {
  const [call] = useMutation<Output, Input>(GqlReportErrorSchema);

  return (error: ReportableError): Promise<void> =>
    new Promise((resolve) => {
      call({ variables: { error } })
        .catch((ex) => {
          console.error('Fail reporting web error', ex);
        })
        .finally(() => resolve(void 0));
    });
};
